const messages = {
  title: "A BS Plus-ról",
  description: "About page description",
};

export default {
  messages,
};
